import { render, staticRenderFns } from "./WXCW03Avg.vue?vue&type=template&id=775b0506&"
import script from "./WXCW03Avg.vue?vue&type=script&lang=js&"
export * from "./WXCW03Avg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports